import { Button, Table } from 'antd';
import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import ModuleApi from '../../functions/api/user/ModuleApi';
import MyUtil from '../../functions/MyUtil';
import ButtonFormatter from './ButtonFormatter';

class ListModule extends Component {
  constructor(props) {
    super(props);
    this.state = {
      listModules: [],
      redirectAdd: false,
      widthWindow: window.innerWidth,
    };
  }

  async componentDidMount() {
    const listModules = await ModuleApi.getAllModules();
    this.setState({ listModules });
  }

  activeFormatter = (cell, row) => {
    return (
      <ButtonFormatter
        cell={cell}
        row={row}
        onChangeList={this.handleChangeList}
        list={this.state.listModules}
      />
    );
  };

  handleInsertButtonClick = () => {
    this.setState({ redirectAdd: true });
  };

  handleChangeList = (list) => {
    this.setState({ listModules: list });
  };

  render() {
    const { listModules } = this.state;
    const canAdd = MyUtil.hasPermission(this.props.match_parent.url, 'add');

    if (this.state.redirectAdd) {
      return <Redirect push to={`${this.props.match_parent.url}/add`} />;
    }

    const columnModules = [
      {
        title: 'Module ID',
        dataIndex: 'module_id',
        key: 'module_id',
        fixed: 'left',
      },
      {
        title: 'Module Name',
        dataIndex: 'module_name',
        key: 'module_name',
        fixed: 'left',
      },
      {
        title: 'Description',
        dataIndex: 'description',
        key: 'description',
      },
      {
        title: 'Route Path',
        dataIndex: 'route_path',
        key: 'route_path',
      },
      {
        title: 'Chỉnh sửa',
        render: this.activeFormatter,
        fixed: 'right',
      },
    ];

    return (
      <div className="content">
        {canAdd && (
          <Button
            onClick={this.handleInsertButtonClick}
            type="primary"
            size="large"
          >
            Thêm
          </Button>
        )}
        <Table
          rowKey="module_id"
          size="small"
          columns={columnModules}
          dataSource={listModules}
          scroll={{ x: 'max-content' }}
        />
      </div>
    );
  }
}

export default ListModule;
